import { useState, useContext, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { Logo, Button, Icon, AuthContext } from "@/components/lib";
import Style from "./app.tailwind";

export function AppNav(props) {
  // state
  const [open, setOpen] = useState(false); // mobile is open
  const context = useContext<any>(AuthContext);
  const navbarRef = useRef(null);

  const handleClickOutside = (event) => {
    if (navbarRef.current && !navbarRef.current.contains(event.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    if (open) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [open]);

  return (
    <>
      {/* mobile navbar */}
      <nav className="md:hidden fixed top-6 right-8 z-20 bg-transparent">
        <Button
          icon={open ? "x" : "menu"}
          color="dark"
          size={18}
          className="md:hidden absolute left-0 top-0 z-10"
          action={(e) => setOpen(!open)}
        />

        <section
          className="md:hidden fixed flex-col p-2 z-[9] top-2 left-3 right-3 bg-[#07101B] text-white rounded"
          ref={navbarRef}
          style={{
            boxShadow: "0 0 5em rgba(0, 0, 0, 0.25)",
            transition: "all 0.2s ease-in-out",
            display: open ? "flex" : "none"
          }}
        >
          <div className="flex flex-col">
            <Logo className="w-24 mx-auto mb-2" />
            {props.items?.map((item) => {
              if (item.link) {
                return (
                  <NavLink
                    key={item.label}
                    to={item.link}
                    onClick={() => setOpen(false)}
                    className={({ isActive }) =>
                      isActive
                        ? "bg-[#CF2027] " + Style.mobileLinkStyle
                        : Style.mobileLinkStyle
                    }
                  >
                    {item.icon && (
                      <Icon
                        className="mr-1"
                        image={item.icon}
                        size={18}
                        color="light"
                      />
                    )}
                    {item.customIcon && item.customIcon}
                    {item.label && <span>{item.label}</span>}
                  </NavLink>
                );
              }
              return false;
            })}
          </div>
          {context.user ? (
            <div onClick={context.signout} className={Style.mobileLinkStyle}>
              <Icon className="mr-1" image="log-out" size={18} color="light" />
              <span className="label">Sign Out</span>
            </div>
          ) : (
            <NavLink to="/signin" className={Style.mobileLinkStyle}>
              <Icon className="mr-1" image="log-in" size={18} color="light" />
              <span className="label">Login</span>
            </NavLink>
          )}
        </section>
      </nav>

      {/* Desktop navbar */}
      <nav className="hidden fixed top-0 md:flex w-full bg-[#07101B] p-4 z-50 font-extrabold">
        <section className="flex items-center w-full">
          <Logo className="w-48 mr-auto" />
          {props.items?.map((item) => {
            if (item.link) {
              return (
                <NavLink
                  key={item.label}
                  to={item.link}
                  style={{ width: "fit-content" }}
                  className={({ isActive }) =>
                    isActive
                      ? "bg-[#CF2027] " + Style.desktopLinkStyle
                      : Style.desktopLinkStyle
                  }
                >
                  {item.icon && (
                    <Icon image={item.icon} size={18} color="light" />
                  )}
                  {item.customIcon && item.customIcon}
                  {item.label && (
                    <span className="text-white">{item.label}</span>
                  )}
                </NavLink>
              );
            }

            return false;
          })}
          {context.user ? (
            <div
              onClick={context.signout}
              className="flex items-center bg-[#0233a1] px-4 xl:px-6 py-3 ml-4 rounded-full text-white cursor-pointer text-[9px] lg:text-[12px] xl:text-base"
            >
              Sign Out
            </div>
          ) : (
            <a
              href="/signin"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 bg-[#0233a1] px-4 xl:px-6 py-3 ml-4 rounded-full text-white text-[9px] lg:text-[12px] xl:text-base"
            >
              Login
            </a>
          )}
        </section>
      </nav>
    </>
  );
}
